var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentPage',[_c('div',{staticClass:"content"},[_c('HistoryTable')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }